import React from 'react';
import { MapPin, Mail, Phone } from 'lucide-react';
import './ContactOfficesSection.css';

const ContactOfficesSection = () => {
  return (
    <div className="contact-offices-wrapper">
      <div className="contact-offices-container">
        <div className="contact-info-panel">
          <div className="panel-header">
            <p className="panel-subtitle">OUR OFFICES</p>
            <h1 className="panel-title">
              <span className="title1-highlight">Get in</span> Touch
            </h1>
            <p className="panel-description">
              Come and visit our quarters or simply send us an email anytime you want. We
              are open to all suggestions from our clients.
            </p>
          </div>

          <div className="contact-details-grid">
            <div className="contact-detail-item">
              <div className="detail-icon-wrapper">
                <MapPin size={28} />
              </div>
              <div className="detail-content">
                <h3 className="detail-title">London Office</h3>
                <p className="detail-text">128 City Road,</p>
                <p className="detail-text">London, EC1V 2NX</p>
              </div>
            </div>

            <div className="contact-detail-item">
              <div className="detail-icon-wrapper">
                <MapPin size={28} />
              </div>
              <div className="detail-content">
                <h3 className="detail-title">India Office</h3>
                <p className="detail-text">Embassy Golf Links,</p>
                <p className="detail-text">Business Park, Bengaluru,</p>
                <p className="detail-text">Karnataka</p>

              </div>
            </div>

            <div className="contact-detail-item">
              <div className="detail-icon-wrapper">
                <Mail size={28} />
              </div>
              <div className="detail-content">
                <h3 className="detail-title">Email us</h3>
                <p className="detail-text">Info@devopstrioglobal.co.uk</p>
                <p className="detail-text">office@devopstrio.co.uk</p>
              </div>
            </div>

            <div className="contact-detail-item">
              <div className="detail-icon-wrapper">
                <Phone size={28} />
              </div>
              <div className="detail-content">
                <h3 className="detail-title">Call us</h3>
                <p className="detail-text">+44 1784 64 0216</p>
                <p className="detail-text">020 7996 223</p>
              </div>
            </div>
          </div>
        </div>

        <div className="map-panel">
          <div className="map-overlay-image">
            {/* <img
              src="https://avantage.bold-themes.com/hr/wp-content/uploads/sites/5/2019/04/img-map-cover.png"
              alt="Map overlay decoration"
              className="overlay-decoration"
            /> */}
          </div>
          <div className="map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2482.6278290098406!2d-0.12472768422982835!3d51.51733897963655!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48761b2f0c1e5b2b%3A0x3a4d0c7e5e9b8e8a!2sBloomsbury%20Square%2C%20London%20WC1B%204EA%2C%20UK!5e0!3m2!1sen!2sin!4v1234567890123!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="London Office Location"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactOfficesSection;